
import React from 'react';

interface StarIconProps extends React.SVGProps<SVGSVGElement> {}

const IndigoPinIcon: React.FC<StarIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    {...props}
  >
    <path 
      fillRule="evenodd" 
      d="M9.69 2.116A3.75 3.75 0 0 1 12 1.5a3.75 3.75 0 0 1 2.31.616V1.5A1.5 1.5 0 0 1 12 .75a1.5 1.5 0 0 1-2.31.616Z"
    />
    <path 
      fillRule="evenodd" 
      d="M9.69 2.116c1.03-.624 2.59-.624 3.62 0l.001.002c.104.063.202.13.292.202l.003.002c.172.132.33.275.475.428l.002.002c.05.05.096.103.14.158l.002.002c.077.098.147.203.208.314l.002.004c.03.055.056.112.078.172l.002.006c.043.118.075.243.095.372l.001.006A8.25 8.25 0 0 1 12 22.5a8.25 8.25 0 0 1-2.31-18.128l-.001-.006c.02-.129.052-.254.095-.372l.002-.006c.022-.06.048-.117.078-.172l.002-.004a2.75 2.75 0 0 1 .208-.314l.002-.002c.044-.055.09-.108.14-.158l.002-.002a4.028 4.028 0 0 1 .475-.428l.003-.002c.09-.072.188-.139.292-.202l.001-.002ZM12 12.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" 
      clipRule="evenodd" 
    />
  </svg>
);

export default IndigoPinIcon;
